export enum GameInstancePlayerEmailTypes {
  PendingDrawNotification = 1,
  DrawResultsNotification = 2
}
